import React, { useEffect, useState } from 'react';
import { IonItem, IonText, IonToggle } from '@ionic/react';

import './ABMUsers.css';

interface Props {
  text: string,
  id: string,
  check: boolean,
  parentCallback: (check: boolean, id: string) => void,
  disabled?: boolean
}

const ToggleUserConsulta: React.FC<Props> = ({ text, id, check, parentCallback, disabled }) => {
  const [checked, setChecked] = useState<boolean>(check)

  useEffect(() => {
    setChecked(check);
  }, [check]);
  

  useEffect(() => {
    if (disabled !== undefined && disabled === false) {
      setChecked(check)
    }
  }, [disabled])

  const handleChange = (e: any) => {
    const newChecked = e.detail.checked;
    setChecked(newChecked);
    parentCallback(newChecked, id);
  };

  return (
    <IonItem lines="none" className="toggle-ABMConsulta-item">
      <IonText className="toggle-ABMConsulta-text">{text}</IonText>
      {
        disabled ?
          <IonToggle color="secondary" checked={true} disabled slot="start" mode="ios" className="toggle-ABMConsulta" id={id} />
          :
          <IonToggle color="secondary" checked={checked} onIonChange={handleChange} slot="start" mode="ios" className="toggle-ABMConsulta" id={id} />
      }
    </IonItem>
  );
};

export default ToggleUserConsulta;